import apiAxiosClient from './apiAxiosClient';

const authApi = {
    login(params) {
        const url = '/api/auth/login';
        return apiAxiosClient.post(url, params);
    },
    logout(params) {
        const url = '/api/auth/logout';
        return apiAxiosClient.post(url, params);
    },
    checkAuth() {
        const url = '/api/auth/check-auth';
        return apiAxiosClient.get(url);
    },
};

export default authApi;
